import type { FC } from 'react';
import ContentLoader from 'react-content-loader';

import { createArray } from 'app/utils/array';

import style from './style.scss';

interface Props {
  nbLines?: number;
}

const LINE_HEIGHT = 13;

const BlueprintListPlaceholder: FC<Props> = ({ nbLines = 3 }) => (
  <div className={style.container}>
    <div className={style.headLine}>
      <ContentLoader width={951}>
        <rect x={74} y={11} width={53} height={LINE_HEIGHT} />
        <rect x={306} y={11} width={71} height={LINE_HEIGHT} />
        <rect x={407} y={11} width={71} height={LINE_HEIGHT} />
        <rect x={617} y={11} width={71} height={LINE_HEIGHT} />
      </ContentLoader>
    </div>
    {createArray(nbLines).map((_, index) => (
      <div key={index} className={style.line}>
        <ContentLoader width={951}>
          <rect x={28} y={29} width={116} height={LINE_HEIGHT} />
          <rect x={260} y={29} width={51} height={LINE_HEIGHT} />
          <rect x={361} y={29} width={51} height={LINE_HEIGHT} />
          <rect x={571} y={29} width={51} height={LINE_HEIGHT} />
        </ContentLoader>
        <div className={style.actions}>
          <ContentLoader width={86}>
            <rect x={26} y={29} width={LINE_HEIGHT} height={LINE_HEIGHT} />
            <rect x={47} y={29} width={LINE_HEIGHT} height={LINE_HEIGHT} />
          </ContentLoader>
        </div>
      </div>
    ))}
  </div>
);

BlueprintListPlaceholder.displayName = 'BlueprintListPlaceholder';

export default BlueprintListPlaceholder;
